// PeptideVault v6.5 — Exports tab

// ══════════════════════════════════════════════════════
// RENDER: EXPORTS TAB
// ══════════════════════════════════════════════════════
function renderExportsTab() {
  return `
  <div style="animation:fadeIn .25s ease;max-width:600px">
    <div class="row" style="margin-bottom:20px">
      <h2 style="font-size:20px;font-weight:700">Exports</h2>
    </div>

    <!-- Provider / Personal Summary -->
    <div class="card" style="margin-bottom:12px">
      <div class="card-header"><div class="card-title">🧾 Provider / Personal Summary</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">A clean, printable summary of active peptides, supplements, and protocols. For personal records or sharing with a provider. Educational only — includes required disclaimer.</div>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <select class="form-input form-select" id="summary-user" style="width:auto;font-size:13px">
            <option value="all">Combined (household)</option>
            ${(S.users||[]).map(u=>`<option value="${u.id}">${esc(u.name)}</option>`).join('')}
          </select>
          <select class="form-input form-select" id="summary-scope" style="width:auto;font-size:13px">
            <option value="full">Full (peptides + supplements)</option>
            <option value="peptides">Peptides only</option>
            <option value="supplements">Supplements only</option>
          </select>
          <button class="btn btn-primary btn-sm" onclick="printProviderSummary()">${ICONS.export} Generate Summary</button>
        </div>
      </div>
    </div>

    <!-- Inventory -->
    <div class="card" style="margin-bottom:12px">
      <div class="card-header"><div class="card-title">📦 Inventory</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">Full inventory with SKU details and current stock levels.</div>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <button class="btn btn-secondary btn-sm" onclick="exportCSV()">${ICONS.export} Inventory CSV</button>
          <button class="btn btn-secondary btn-sm" onclick="exportJSON()">Full JSON Backup</button>
        </div>
      </div>
    </div>

    <div class="card" style="margin-bottom:12px">
      <div class="card-header"><div class="card-title">📍 Locations</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">Peptides use the exact B1/B2 vault map. Supplies retain their original cabinet, drawer, and shelf locations.</div>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <button class="btn btn-secondary btn-sm" onclick="exportPeptideVaultCSV()">${ICONS.export} Peptide Vault Map CSV</button>
          <button class="btn btn-secondary btn-sm" onclick="exportSupplyLocationsCSV()">${ICONS.export} Supply Locations CSV</button>
        </div>
      </div>
    </div>

    <!-- Injections -->
    <div class="card" style="margin-bottom:12px">
      <div class="card-header"><div class="card-title">💉 Injection Schedule</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">${S.injections.length.toLocaleString()} injection records. Export as CSV for spreadsheets or ICS to add to your calendar app.</div>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <button class="btn btn-secondary btn-sm" onclick="exportInjectionCSV()">${ICONS.export} Injections CSV</button>
          <button class="btn btn-secondary btn-sm" onclick="openICSRangeModal()">${ICONS.calendar} Injections ICS</button>
          <button class="btn btn-secondary btn-sm" onclick="exportUpcomingICS()">${ICONS.calendar} Next 90 Days ICS</button>
        </div>
      </div>
    </div>

    <!-- Analytics -->
    <div class="card" style="margin-bottom:12px">
      <div class="card-header"><div class="card-title">📊 Analytics</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">Monthly injection summary with frequency and cost data.</div>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <button class="btn btn-secondary btn-sm" onclick="exportAnalyticsCSV()">${ICONS.export} Analytics CSV</button>
        </div>
      </div>
    </div>

    <!-- Health Data -->
    <div class="card" style="margin-bottom:12px">
      <div class="card-header"><div class="card-title">❤️ Health Data</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">${S.healthData.length.toLocaleString()} health records across ${Object.keys(HEALTH_TYPES).filter(k=>S.healthData.some(d=>d.type===k)).length} metrics.</div>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <button class="btn btn-secondary btn-sm" onclick="exportHealthCSV()">${ICONS.export} Health Data CSV</button>
        </div>
      </div>
    </div>

    <!-- Notes -->
    <div class="card" style="margin-bottom:12px">
      <div class="card-header"><div class="card-title">📝 Research Notes</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">${S.notes.length} research notes.</div>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <button class="btn btn-secondary btn-sm" onclick="exportNotesCSV()">${ICONS.export} Notes CSV</button>
        </div>
      </div>
    </div>

    <!-- Export All -->
    <div class="card" style="border-color:var(--blue)">
      <div class="card-header"><div class="card-title" style="color:var(--blue)">⬇️ Export Everything</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:8px">
        <div style="font-size:13px;color:var(--text3)">Download a complete JSON backup containing all data — can be imported back to restore everything.</div>
        <button class="btn btn-primary btn-sm" onclick="exportJSON()">${ICONS.export} Full JSON Backup</button>
      </div>
    </div>
  </div>`
}

// ── Export helpers ────────────────────────────────────
function exportMonthCSV(monthKey) {
  const injs = S.injections
    .filter(i => i.date.startsWith(monthKey))
    .sort((a,b) => a.date.localeCompare(b.date) || injTimeMinutes(a.time) - injTimeMinutes(b.time))
  const rows = [['Date','Time','Peptide','Dosage','Draw Units','Notes']]
  injs.forEach(inj => {
    rows.push([
      new Date(inj.date+'T12:00:00').toLocaleDateString('en-US'),
      fmt12(inj.time), inj.peptideName, inj.dosage, inj.drawUnits, inj.notes||''
    ])
  })
  downloadCSV(rows, 'PeptideVault_Injections_' + monthKey + '.csv')
  closeModal()
  showToast('Month exported')
}

async function exportUpcomingICS() {
  // Export the next 90 days so the file stays within Google's import limit
  const today = new Date(); today.setHours(0,0,0,0)
  const end = new Date(); end.setDate(end.getDate() + 90)
  const start = localDateStr(today)
  const endStr = localDateStr(end)
  await exportInjectionICS(start, endStr)
}

async function exportAnalyticsCSV() {
  const today = new Date(); today.setHours(23,59,59,999)
  const startDate = S.analyticsStart ? new Date(S.analyticsStart + 'T00:00:00') : null
  const endDate   = S.analyticsEnd   ? new Date(S.analyticsEnd   + 'T23:59:59') : today

  const monthMap = {}
  S.injections.forEach(inj => {
    const d = new Date(inj.date+'T12:00:00')
    if (d > today || d > endDate) return
    if (startDate && d < startDate) return
    const key   = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`
    const label = d.toLocaleDateString('en-US',{month:'long',year:'numeric'})
    if (!monthMap[key]) monthMap[key] = { label, total:0, peptides:{} }
    monthMap[key].total++
    monthMap[key].peptides[inj.peptideName] = (monthMap[key].peptides[inj.peptideName]||0)+1
  })

  // Cost per injection lookup
  const costPerInjMap = {}
  for (const p of S.peptides) {
    for (const s of (p.skus||[])) {
      const cost = +(s.costPerVial||0), doses = +(s.dosesPerVial||0)
      if (!cost || !doses) continue
      const perInj = cost/doses
      if (!costPerInjMap[p.name] || perInj < costPerInjMap[p.name]) costPerInjMap[p.name] = perInj
    }
  }

  const costByMonth = {}
  S.injections.forEach(inj => {
    const perInj = costPerInjMap[inj.peptideName]
    if (!perInj) return
    const d = new Date(inj.date+'T12:00:00')
    if (d > today || d > endDate) return
    if (startDate && d < startDate) return
    const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`
    costByMonth[key] = (costByMonth[key]||0) + perInj
  })

  const allPeps = [...new Set(S.injections.map(i=>i.peptideName))]
  const header = ['Month','Total Injections','Estimated Cost ($)', ...allPeps]
  const rows = [header]
  Object.entries(monthMap).sort((a,b)=>a[0].localeCompare(b[0])).forEach(([key,v]) => {
    rows.push([v.label, v.total, (costByMonth[key]||0).toFixed(2), ...allPeps.map(p=>v.peptides[p]||0)])
  })
  downloadCSV(rows, 'PeptideVault_Analytics_' + localDateKey() + '.csv')
  showToast('Analytics exported')
}

async function exportHealthCSV() {
  if (!S.healthData.length) { showToast('No health data to export'); return }
  const sorted = [...S.healthData].sort((a,b) => a.date.localeCompare(b.date) || a.type.localeCompare(b.type))
  const rows = [['Date','Metric','Value','Unit']]
  sorted.forEach(d => {
    rows.push([
      new Date(d.date+'T12:00:00').toLocaleDateString('en-US'),
      HEALTH_TYPES[d.type]?.label || d.type, d.value, d.unit||''
    ])
  })
  downloadCSV(rows, 'PeptideVault_Health_' + localDateKey() + '.csv')
  showToast('Health data exported')
}

async function exportNotesCSV() {
  if (!S.notes.length) { showToast('No notes to export'); return }
  const sorted = [...S.notes].sort((a,b) => b.date.localeCompare(a.date))
  const rows = [['Date','Peptide','Title','Notes']]
  sorted.forEach(n => {
    const pepName = n.peptideId ? (getPeptide(n.peptideId)?.name||'') : ''
    rows.push([new Date(n.date+'T12:00:00').toLocaleDateString('en-US'), pepName, n.title, n.body||''])
  })
  downloadCSV(rows, 'PeptideVault_Notes_' + localDateKey() + '.csv')
  showToast('Notes exported')
}

function downloadCSV(rows, filename) {
  const csv = rows.map(r => r.map(c => '"' + String(c||'').replace(/"/g,'""') + '"').join(',')).join('\n')
  if (window.api) {
    window.api.showSaveDialog({ title:'Save CSV', defaultPath:filename, filters:[{name:'CSV',extensions:['csv']}] })
      .then(p => { if (p) window.api.writeFile(p, csv).then(()=>showToast('Saved')) })
  } else {
    const a = document.createElement('a')
    a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
    a.download = filename; a.click()
  }
}

export {
  renderExportsTab,
  exportMonthCSV,
  exportUpcomingICS,
  exportAnalyticsCSV,
  exportHealthCSV,
  exportNotesCSV,
  downloadCSV
}
